/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { AnalyticsConstants, Operations, Payload } from '@tivocorp/tivo-webapp-loggers';

import { Log } from '../logging';
import { Storage } from '../storage';

export class CubiwareHttpClient {
    private static TAG = 'CubiwareHttpClient';

    private cubiwareUrl: string;

    public constructor(cubiwareUrl: string) {
        this.cubiwareUrl = this.modifyCubiwareUrl(cubiwareUrl);
    }

    // eslint-disable-next-line class-methods-use-this
    private modifyCubiwareUrl(url: string): string {
        const formattedUrl = url
            .replace('http://', 'https://')
            .replace('https://', 'https://kaveri.');
        return formattedUrl;
    }

    public static isCubiAuthAlreadyPerformed(): boolean {
        return !!Storage.getInstance().getItem(Storage.Keys.CUBIWARE_AUTH_DONE);
    }

    public async provisionDevice(
        bodyId: String,
        caDeviceId: String,
        samlToken: String,
        deviceType: String,
    ): Promise<void> {
        try {
            await fetch(`${this.cubiwareUrl}/authenticate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    device_external_id: bodyId,
                    device_uuid: caDeviceId,
                    saml_token: samlToken,
                    device_profile_name: deviceType,
                }),
            });
            Storage.getInstance().setItem(Storage.Keys.CUBIWARE_AUTH_DONE, true);
        } catch (error) {
            Storage.getInstance().setItem(Storage.Keys.CUBIWARE_AUTH_DONE, false);
            Log.e(CubiwareHttpClient.TAG, `Error during device provisioning: ${error}`);
            const payload: Payload = new Payload();
            payload.add(AnalyticsConstants.Fields.EVENT_NAME, CubiwareHttpClient.TAG);
            payload.add(AnalyticsConstants.Fields.REFRENCE_TIME, Date.now());
            payload.add(AnalyticsConstants.Fields.EVENT_TYPE, 'error');
            payload.add('error', JSON.stringify(error));
            Operations.log(payload);
            throw error;
        }
    }
}
